import { Typography, Switch } from "@joonapp/web-shared"
import { Trans, useTranslation } from "react-i18next"

import { CloseButton } from "../../../components/closeButton/CloseButton"
import SlideUpModal from "../../../components/slideUpModal/SlideUpModal"
import { useUpdateChildAssignmentMutation } from "../../../networking/rewards/mutations"
import { useCustomRewardsQuery } from "../../../networking/rewards/queries"
import { trackAnalyticEvent } from "../../../util/analytics"
import { ANALYTIC_EVENTS } from "../../../util/analytics"
import useAutoApproveModalStore from "../hooks/useAutoApproveModalStore"

const AutoApproveSettingsModal = () => {
  const { isOpen, onClose, rewardId, childId } = useAutoApproveModalStore()
  const useUpdateChildAssignment = useUpdateChildAssignmentMutation()
  const { t } = useTranslation()

  const { data: rewards } = useCustomRewardsQuery()
  const reward = rewards?.find((reward) => reward.id === rewardId)

  const childAssignment = reward?.assignments?.find(
    (assignment) => assignment.user_id === childId
  )

  const isAutoApproveEnabled = childAssignment?.bypass_redeem ?? false

  const onToggleAutoApprove = () => {
    if (!childAssignment) return
    trackAnalyticEvent(ANALYTIC_EVENTS.TOGGLE_AUTO_REDEEM, {
      enabled: !childAssignment.bypass_redeem,
    })
    useUpdateChildAssignment.mutate({
      assignmentId: childAssignment.id,
      bypassRedeem: !childAssignment.bypass_redeem,
    })
  }

  return (
    <SlideUpModal
      isOpen={isOpen}
      onClose={onClose}
      zIndex={1000}
      backgroundType="overlay"
      size="fit-content"
    >
      <div className="flex flex-col gap-4 bg-bgXLightGray p-4">
        <CloseButton onClick={onClose} />
        <Typography variant="bodyBold">{t("AASM_TITLE")}</Typography>
        <div className="flex flex-col gap-2 p-3 rounded-md bg-backgroundPrimary border border-borderPrimary">
          <div className="flex flex-row gap-2 items-center justify-between">
            <Typography variant="bodySmallBold">
              {t("AASM_AUTO_APPROVE_STATE", {
                state: isAutoApproveEnabled
                  ? t("DOTER_AI_ON")
                  : t("DOTER_AI_OFF"),
              })}
            </Typography>
            <Switch
              checked={isAutoApproveEnabled}
              onChange={onToggleAutoApprove}
              name="repeat-quest"
              variant="small"
            />
          </div>
          {isAutoApproveEnabled ? (
            <Typography variant="bodyXSmall">
              <Trans
                i18nKey="AASM_ENABLED_DESC"
                components={{
                  b: <Typography variant="bodyXSmallBold">{""}</Typography>,
                }}
              />
            </Typography>
          ) : (
            <Typography variant="bodyXSmall">
              <Trans
                i18nKey="AASM_DISABLED_DESC"
                components={{
                  b: <Typography variant="bodyXSmallBold">{""}</Typography>,
                }}
              />
            </Typography>
          )}
        </div>
      </div>
    </SlideUpModal>
  )
}

export default AutoApproveSettingsModal
